import {releaseNotesURL} from '../../constants/sixtForceConstants'

export const getAnchorProperties = () => {
  const anchorProperties = [
    {
      iconName: 'ico_sixt',
      name: 'Me & Sixt',
      subMenu: [
        {
          name: 'Profile',
          to: '/profile',
        },
      ],
    },
    {
      iconName: 'ico_wiki_white',
      name: 'wiki',
      to: '/wiki',
    },
    {
      iconName: 'ico_think_tank_white',
      name: 'Think tank',
      to: '/think-tank/tabs/home/all-ideas',
    },
    {
      iconName: 'ico_bureaucracybutton',
      name: 'Bureaucracy Button',
      to: '/bureaucracy/my-concerns',
    },
    {
      iconName: 'ico_directlyto',
      name: 'Directly To',
      to: '/directly-to/my-questions',
    },
    {
      iconName: 'announcement',
      name: 'Release Notes',
      targetBlank: true,
      to: releaseNotesURL,
    },
  ]
  return anchorProperties
}
